import { Fragment } from "react"
import { Link } from "react-router-dom"
import { useAuthStore } from "../stores/authStore"
import { adminModules } from "../constant/adminModules"

function Sidebar({ sidebarOpen, setSidebarOpen, currentPath }) {
  const { user } = useAuthStore()

  const filteredNavigation = adminModules
    .filter(item => item.roles.includes(user?.role))
    .map(item => ({
      ...item,
      current:
        item.href === currentPath || currentPath.startsWith(item.href)
    }))


  return (
    <>
      <div
        className={`
        fixed inset-y-0 left-0 z-50 w-64 glass-effect transform transition-transform duration-300 ease-in-out md:hidden
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
      `}
      >
        <SidebarContent
          navigation={filteredNavigation}
          setSidebarOpen={setSidebarOpen}
        />
      </div>

      <div className='hidden md:flex md:w-64 md:flex-col'>
        <div className='flex flex-col flex-grow glass-effect border-r-0'>
          <SidebarContent navigation={filteredNavigation} />
        </div>
      </div>
    </>
  )
}

function SidebarContent({ navigation, setSidebarOpen }) {
  return (
    <div className='flex flex-col h-screen'>
      <div className='flex items-center flex-shrink-0 px-4 py-4 border-b border-gray-200'>
        <div className='flex items-center'>
          <div className='flex-shrink-0'>
            <div className='w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg'>
              <span className='text-white font-bold text-sm'>B360</span>
            </div>
          </div>
          <div className='ml-3'>
            <h1 className='text-lg font-bold text-gray-800'>Barangay 360</h1>
            <p className='text-xs text-gray-500'>Management System</p>
          </div>
        </div>
      </div>

      <nav className='flex-1 px-3 py-2 overflow-y-auto max-h-[calc(100vh-140px)]'>
        <div className='space-y-0.5'>
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              onClick={() => setSidebarOpen && setSidebarOpen(false)}
              className={`
                group flex items-center px-3 py-1.5 text-sm font-medium rounded-md transition-colors duration-200
                ${item.current
                  ? "bg-primary-100 text-primary-900 border-r-2 border-primary-600"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }
              `}
            >
              <item.icon
                className={`
                  flex-shrink-0 w-4 h-4 mr-3
                  ${item.current
                    ? "text-primary-600"
                    : "text-gray-400 group-hover:text-gray-500"
                  }
                `}
              />
              <div className='flex-1 min-w-0'>
                <div className='font-medium text-sm truncate'>{item.name}</div>
                {item.description && (
                  <div className='text-xs text-gray-500 mt-0.5 truncate'>
                    {item.description}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </nav>

      <div className='flex-shrink-0 border-t border-gray-200 p-3'>
        <div className='text-xs text-gray-500 text-center'>
          <p>© {new Date().getFullYear()} Barangay 360</p>
          <p>Management System v1.0</p>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
